import { render } from "./Education.vue?vue&type=template&id=0a8a8e00&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0a8a8e00"

export default script